export default __webpack_public_path__ + "imgs/2ed98e9d.png";